/*
 * @Author: nathan
 * @Date: 2022-02-18 13:39:18
 * @LastEditors: 蒋时阳
 * @LastEditTime: 2026-03-17 10:31:29
 * @FilePath: /insurance-group-pc/src/store/getters.js
 * @Description:
 *
 * Copyright (c) 2022 by 用户/公司名, All Rights Reserved.
 */
const getters = {
    loginStatus: state => state.user.loginStatus,
    userId: state => state.user.userId,
    userName: state => state.user.userName,
    userLogo: state => state.user.userLogo,
    userUuid: state => state.user.userUuid,
    isProPriceShow: state => state.user.isProPriceShow,
    showLogin: state => state.user.showLogin,
    goPageAfterLogin: state => state.user.goPageAfterLogin,
    header: state => state.user.header,
    userTier: state => state.user.userTier,
    agencyName: state => state.user.agencyName,//团险商户
    name: state => state.user.name, //团险名字
    isTXSystem: state => state.user.isTXSystem,//团险系统
    appId: state => state.user.appId ,
    openId: state => state.user.openId,
    searchProductId: state => state.productFilter.searchProductId,
    company: state => state.productFilter.company,
    productType: state => state.productFilter.productType,

    pageSize: state => state.order.pageSize,
    pageIndex: state => state.order.pageIndex,
    total: state => state.order.total,
    filterStr: state => state.order.filterStr,

    unfinishPageSize: state => state.unfinishOrder.pageSize,
    unfinishPageIndex: state => state.unfinishOrder.pageIndex,
    unfinishTotal: state => state.unfinishOrder.total,
    wYBroker: state => state.user.wYBroker,
    quasiA: state => state.user.quasiA,
    userUuid: state => state.user.userUuid,

    assembleError: state => state.writeStore.assembleError,
    // 是否测试账号，线上19000000002，测试17600000004
    isTestUser: state => ['19000000002', '17600000005', '17600000004', '17600000003', '17600000002'].includes(state.user.tel),
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js